import { Component } from '@angular/core';

@Component({
    template: require('./welcome.component.html')
})
export class WelcomeComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/home/welcome.component.ts